import tw from "./tailwind"

export { tw as default }
